import React, { Component } from 'react';
import { Button, Input, Select, Icon,DatePicker } from 'antd';
import API_URL from '../../../../../common/url';
import ExportUtil from '../../../../../common/ExportUtil';
import SelectBa from '../../../components/SelectBa';
import moment from 'moment';
import SearchRetrieve from '../../../../common/SearchRetrieve.new.js';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
        };
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        const { searchParams } = this.props;
        const url = API_URL.home.exportARContractList;
        const{date}=searchParams;
        searchParams.date=date?date:moment().format('YYYY-MM');
        ExportUtil.export({ ...searchParams }, null, url);
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerCompany':
            case 'pm':
            case 'pml':
            case 'ba': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'customerBaName': {
                const { lastLeaf, checkedKeys, expandedKeys } = value;
                searchParams.lastLeaf = lastLeaf;
                searchParams.checkedKeys = checkedKeys;
                searchParams.expandedKeys = expandedKeys;
                searchParams.customerBaNameIds = (lastLeaf || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (lastLeaf || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { searchParams, belongingToUnitList, contractTypeList, businessList } = this.props;
        const { expand } = this.state;
        let beginDateDefault = moment().format('YYYY-MM');
        const {
            date = beginDateDefault,
            milestoneDateShow,
            planInvoiceDateShow,
            belongingToUnit,
            lastLeaf, checkedKeys, expandedKeys
        } = searchParams;
        const belongingToUnitOptions = belongingToUnitList.map(i => <Option key={String(i.unitOfBelongingId)}>{i.unitOfBelongingName}</Option>);
        const contractTypeOptions = contractTypeList.map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                <div className="search-item">
                        <label htmlFor="" className="ui-label">统计月份</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={date ? moment(date) : null}
                            //disabledDate={this.disabledDate}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'date')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">项目简称</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 160 }}
                            value={searchParams.investigationName}
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                        />
                    </div>      
                    <div className="search-item">
                        <div className="ui-label">业务线</div>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 140}}
                            value={searchParams.lineOfBusiness}
                            onChange={value => this.handleChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>      
                    <div className="search-item">
                        <div className="ui-label">JDE主项目号</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 140 }}
                            onKeyPress={this.handleKeyPress}
                            value={searchParams.investigationJdeMainCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeMainCode')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">JDE项目号</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 140 }}
                            value={searchParams.investigationJdeCode}
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeCode')}
                        />
                    </div>
                   <div className="search-item">
                        <div className="ui-label">客户付款单位</div>
                        <SearchRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 160 }}
                            placeholder="输入客户付款单位检索"
                            value={searchParams.customerCompanyName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(option) => this.handleChange(option, 'customerCompany')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">计收入确认方式</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 140}}
                            value={searchParams.contractTypeId}
                            onChange = {value => this.handleChange(value, 'contractTypeId')}
                        >
                            {contractTypeOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">PM</div>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 160 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.pmName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'pm')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">预计开票月份</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={planInvoiceDateShow ? moment(planInvoiceDateShow) : null}
                            //disabledDate={this.disabledDate}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'planInvoiceDateShow')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">milestone到达月份</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={milestoneDateShow ? moment(milestoneDateShow) : null}
                            //disabledDate={this.disabledDate}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'milestoneDateShow')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">收入归属单位</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 140}}
                            value={belongingToUnit ? String(belongingToUnit) : undefined}
                            onChange={value => this.handleChange(value, 'belongingToUnit')}
                        >
                            {belongingToUnitOptions}
                        </Select>
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
                <SelectBa ref={el => this.selectBaRef = el}
                lastLeaf={lastLeaf}
                checkedKeys={checkedKeys}
                expandedKeys={expandedKeys}
                onChange={args => this.handleChange(args, 'customerBaName')} />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ARSheet/ARSheetS/TablePage/Filter.js